import './public-path'
import Vue from 'vue'
import App from './App.vue'
import routes from './router'
import 'amfe-flexible';
import { store as commonStore } from 'common'
import store from './store'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { hasPermission, platform } from './utils/utils';
import navBar from "@/pages/components/navBar.vue";
import tabBar from "@/pages/components/tabBar.vue";
// 引入防抖节流函数文件
import { debounce, throttle } from './utils/dbucTrtl.js';
import VueScroll from 'vuescroll';
Vue.use(ElementUI);
Vue.use(VueScroll);
// 全局注册组件
Vue.component('navBar', navBar);
Vue.component('tabBar', tabBar);
Vue.config.productionTip = false
let instance = null

//切换pc/手机地址
function switchPlatform() {
  if (platform().isAndroid || platform().isPhone) {
    window.location.href = `${window.location.protocol}//${window.location.host}?` + getStringAfterChar(window.location.href, '?')
  }
}
switchPlatform()

window.onresize = function () {
  return (() => {
    switchPlatform()
  })();
}

function px2rem(px, handle = true) {
  if (handle) {
    if (/%/ig.test(px)) { // 有百分号%，特殊处理，表述pc是一个有百分号的数，比如：90%
      return px
    } else {
      return (parseFloat(px) / 192) + 'rem'
    }
  } else {
    return px
  }

}
function getStringAfterChar(str, char) {
  const parts = str.split(char);
  return parts.length > 1 ? parts.slice(1).join('') : '';
}
Vue.prototype.$px2rem = px2rem // 放到全局
Vue.prototype.$debounce = debounce;
Vue.prototype.$throttle = throttle;
export const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  // 检测isAuthenticated 是否为true, true代表用户已经登陆
  const url = to.path

  if (!hasPermission(url)) {
    next('/login')
  }  // 未登录跳转至/login
  else next()
  // 已登录则直接跳转
})


// 解决报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}


function render(props = {}) {
  const { container, routerBase } = props
  // const router = new VueRouter({
  //   base: window.__POWERED_BY_QIANKUN__ ? routerBase : process.env.BASE_URL,
  //   mode: 'history',
  //   routes
  // })

  instance = new Vue({
    router,
    store,
    render: (h) => h(App)
  }).$mount(container ? container.querySelector('#app') : '#app')
}

if (!window.__POWERED_BY_QIANKUN__) {
  // 这里是子应用独立运行的环境，实现子应用的登录逻辑

  // 独立运行时，也注册一个名为global的store module
  commonStore.globalRegister(store)
  // 模拟登录后，存储用户信息到global module
  const userInfo = { name: '我是独立运行时名字叫张三' } // 假设登录后取到的用户信息
  store.commit('global/setGlobalState', { user: userInfo })

  render()
}

export async function bootstrap() {
}

export async function mount(props) {

  commonStore.globalRegister(store, props)

  render(props)
}

export async function unmount() {
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
}
